[
    [1,1,"Fetal Related",0,0],
    [2,2,"Elevated NT",1,0],
    [3,2,"Abnormal triple test",1,0],
    [4,2,"Susp fetal cardiac malformation",1,0],
    [5,2,"Extracardiac fetal malformation",1,0],
    [6,2,"Fetal Hydrops",1,0],
    [7,2,"Fetal Arrythmia",1,0],
    [8,3,"Tachycardia",7,0],
    [9,3,"Bradycardia",7,0],
    [10,3,"APB's",7,0],
    [11,2,"Chromosomal abnormality",1,0],
    [12,2,"IUGR",1,0],
    [13,2,"SUA",1,0],
    [14,2,"PRUV",1,0],
    [15,2,"Agenesis of DV",1,0],
    [16,2,"Ventricular assymetry",1,0],
    [17,2,"Fetal anemia",1,0],
    [18,2,"ARSA",1,0],
    [19,2,"DA patency for observation",1,0],
    [20,2,"Cardiomegaly",1,0],
    [21,2,"Dextroversion",1,0],
    [22,2,"Multiple echogenic foci",1,0],
    [23,2,"Tricuspid regurgitation",1,0],
    [24,2,"s/p fetal reduction",1,0],
    [25,1,"Pregnancy Related",0,0],
    [26,2,"Multiple pregnancy",25,0],
    [27,2,"Monochorionic twins",25,0],
    [28,2,"Polyhydramnion",25,0],
    [29,2,"Oligohydramnion",25,0],
    [30,2,"Varices",25,0],
    [31,1,"Maternal Related",0,0],
    [32,2,"Antibody positive connective tissue disease",31,0],
    [33,3,"Anti RO",32,0],
    [34,3,"Anti LA",32,0],
    [35,2,"Consenguinity",31,0],
    [36,2,"Teratogenic medication use",31,0],
    [37,3,"Lithium",36,0],
    [38,2,"Use of prostaglandin synthetase inhibitor",31,0],
    [39,3,"Ibuprofen",38,0],
    [40,2,"Diabetes melitus",31,0],
    [41,2,"Gestational diabetes",31,0],
    [42,2,"Maternal metabolic condition",31,0],
    [43,3,"PKU",42,0],
    [44,2,"Maternal infection",31,0],
    [45,3,"Parvo",44,0],
    [46,3,"CMV",44,0],
    [47,2,"Incomplete pregnancy follow up",31,0],
    [48,2,"family history of CHD",31,0],
    [49,3,"1st degree relative",48,0],
    [50,3,"2nd degree relative",48,0],
    [51,2,"Follow up",31,0],
    [52,2,"Technical difficulty",31,0],
    [53,2,"Assisted conception/IVF",31,0]
]